import styled from "styled-components";
import arrowIcon from "./../../../abc/src/data/icons/chevron-thin-down-dark.svg";
import { isTablet, isMobile, isMobileOnly } from "react-device-detect";

export const MobileFilter = styled.div`
  width: 100%;
  padding: ${(sportsbook) => sportsbook && isMobileOnly && "1rem 0"};
  label {
    color: ${({ theme }) =>
      theme.skin === "abc" || theme.skin === "fun" || theme.skin === "yak"
        ? "#fff"
        : "var(--tabletext)"};
    font-size: 16px;
    /* font-family: "Catamaran", Fallback, sans-serif; */

    letter-spacing: 1px;
  }
  .form-control {
    background-image: url(${arrowIcon}) !important;
    border: none;
  }
  select {
    background: none;
    height: 100%;
    padding: 0;
    font-size: 16px;
    letter-spacing: 1px;
    font-size: 1rem;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    text-transform: capitalize;
    text-align: left;
    color: ${({ theme }) =>
      (theme.skin === "abc" || theme.skin === "fun" || theme.skin === "yak") &&
      "#fff"};

    option {
      background-color: ${({ theme }) =>
        theme.skin === "abc" ? "var(--mainDescriptionABC)" : "var(--lobbybg)"};
      color: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "fun" || theme.skin === "yak"
          ? "#fff"
          : theme.skin === "pub"
            ? "#9A875D"
            : "var(--tabletext)"};
    }
  }
  select:focus {
    color: ${({ theme }) =>
      (theme.skin === "abc" || theme.skin === "fun" || theme.skin === "yak") &&
      "#fff"};
    border: none !important;
    background-color: ${({ theme }) =>
      theme.skin === "abc"
        ? "var(--mainDescriptionABC)"
        : theme.skin === "fun"
          ? "transparent"
          : "var(--lobbybg)"};
    box-shadow: none !important;
    outline: none !important;
  }

  @media (max-width: 770px) {
    display: flex;
    font-weight: 600;
    label {
      margin: 0;
      margin-right: 7px;
    }
  }
`;

export const StyledGameSeachLabel = styled.label`
  position: relative;
  width: ${({ theme }) =>
    theme.skin === "abc" ||
    theme.skin === "nbc" ||
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "yak"
      ? "100%"
      : theme.skin === "pub"
        ? "200px"
        : "370px"};

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid transparent;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.skin === "abc" ? "var(--tabletext)" : "var(--acolor)"};
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  .icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: silver;
  }
  input {
    border-radius: ${({ theme }) =>
      theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun" ||
      theme.skin === "hyc" ||
      theme.skin === "yak"
        ? ""
        : "30px"};
    border: ${({ theme }) => theme.skin === "cac" && "1px solid #979797"};
    &.form-control {
      text-align: left;
      color: ${({ theme }) =>
        (theme.skin === "fun" || theme.skin === "yak") && "#fff"};
      height: ${({ theme }) =>
        theme.skin === "abc" ||
        theme.skin === "yet" ||
        theme.skin === "nbc" ||
        theme.skin === "fun" ||
        theme.skin === "yak"
          ? "50px"
          : "62px"};
      padding: ${({ theme }) =>
        theme.skin === "abc" ||
        theme.skin === "pub" ||
        theme.skin === "cac" ||
        theme.skin === "hyc" ||
        theme.skin === "yak"
          ? "10px 20px"
          : "10px 40px"};
      background-color: ${({ theme }) =>
        theme.skin === "abc" ||
        theme.skin === "nbc" ||
        theme.skin === "yet" ||
        theme.skin === "fun" ||
        theme.skin === "hyc" ||
        theme.skin === "yak"
          ? "var(--bgColorABC)"
          : theme.skin === "pub" || theme.skin === "cac"
            ? "transparent"
            : "var(--lobbybg)"};
      border: ${({ theme }) => theme.skin === "rac" && "none"};
      &::placeholder {
        color: ${({ theme }) =>
          theme.skin === "abc"
            ? "var(--tabletext)"
            : theme.skin === "pub"
              ? "#9A875D"
              : "var(--showall)"};
      }
    }
  }

  @media screen and (max-width: 767px) {
    -webkit-box-shadow: 0px 4px 10px -5px var(--headerbg);
    -moz-box-shadow: 0px 4px 10px -5px var(--headerbg);
    box-shadow: 0px 4px 10px -5px var(--headerbg);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;

    input {
      &.form-control {
        padding: ${({ theme }) =>
          theme.skin === "abc" ? "10px 40px 10px 10px" : ""};
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    -webkit-box-shadow: 0px 4px 10px -5px var(--headerbg);
    -moz-box-shadow: 0px 4px 10px -5px var(--headerbg);
    box-shadow: 0px 4px 10px -5px var(--headerbg);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
`;

export const StyledListGroup = styled.div.attrs({
  className: "list-group",
})`
  text-align: left;
  overflow-x: hidden;
  margin-top: ${({ theme }) =>
    (theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun" ||
      theme.skin === "yak") &&
    "10px"};
  border-radius: ${({ theme }) =>
    theme.skin === "abc" || theme.skin === "nbc" || theme.skin === "yet"
      ? "0.5rem"
      : theme.skin === "fun" || theme.skin === "yak"
        ? "20px 0 20px 20px"
        : ""};
  background-color: ${({ theme }) =>
    theme.skin === "abc" || theme.skin === "nbc" || theme.skin === "yet"
      ? "var(--bgColorABC)"
      : theme.skin === "fun"
        ? "#1b7b8f"
        : "var(--bgcolor)"};

  height: 100%;
  max-height: 50vh;

  max-width: ${({ theme }) =>
    theme.skin === "abc" ||
    theme.skin === "nbc" ||
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "yak"
      ? ""
      : "370px"};

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) =>
      theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun" ||
      theme.skin === "hyc" ||
      theme.skin === "yak"
        ? "var(--bgColorABC)"
        : "var(--bgcolor)"};
    border-radius: ${({ theme }) =>
      (theme.skin === "pub" || theme.skin === "cac" || theme.skin === "hyc") &&
      "0.3rem"};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.skin === "pub"
        ? "#9A875D"
        : theme.skin === "nbc"
          ? "#70328e"
          : theme.skin === "yet" || theme.skin === "fun"
            ? "var(--racProfileMenuCol)"
            : theme.skin === "cac" ||
                theme.skin === "hyc" ||
                theme.skin === "yak" ||
                theme.skin === "rac"
              ? "var(--scollbarCac)"
              : "#1f355e"};
  }

  div {
    box-shadow: 0px 0px 2px 0px var(--tabletext);
    height: 70px;
    color: ${({ theme }) =>
      theme.skin === "fun" || theme.skin === "yak"
        ? "#fff"
        : "var(--tabletext)"};
    position: relative;
    display: block;
    display: block;
    padding: 0.75rem 1.25rem;
    background-color: ${({ theme }) =>
      theme.skin === "yet" || theme.skin === "fun" || theme.skin === "yak"
        ? "var(--bgColorABC)"
        : "var(--bgcolor)"};
  }

  a {
    padding: 0.5rem;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABh0AAACEBAMAAAB2Yff0AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAAARnQU1BAACxjwv8YQUAAAABc1JHQgCuzhzpAAAAJFBMVEUAAAAAAP9/f/9/f/9mZv9VVf9tbf9/f/9/f/9xcf9zc/9mf/8bR+qBAAAADHRSTlMAAQIEBQMHCAYJCwoa4H1RAAAGB0lEQVR42u3dXVIaQRDAcb0B7g1IFSdY9gT4wDMUV0BOAOU7RXmDlJUb6AkSLxdjPiSJwEx/7ezuvx/yEGOI2r/MdPfscHVFSOOm2BjxwyHwgAcCDx8FPxwCD3gg8IAHAg94IAaW1FTiBB7wQOABDwQe8EDgAQ8EHvBA4AEPBJkOGwIPeCDwgAeiC3EdlBrVp6JizIEQVoA2Y5geWD3wgAc84AEPeMADHvAwdA+FZXZg4AEPeMADHvCAB0YJpH8RVQiZXIyHkpJtNVldjE8//syiZ2sImYwHPOChvBZqSXujBA2vFH6qGEAjl2IDD3jAAx7wgAc84AEP7VTOVZsJ3Iko0gpZjwc84AEPeMADHvCAh1bOYeChLQ/GB6DwgAc84MHk9MVY4eFcpi967WGS8oXne7DZReFhoB6Wq7pZLetmWdf16u2XZrWq8UD+t7Mxysum2ijeOdRHf2fz9qEfNt5e6+fHrV8xdlfFBgoPeMADHvCABzzgAQ946GDgAQ94wEMvPcQm/ZnmaHc9NFbfA+0TrGM84AEPeDA8jxHgocOpHoumJQ890YEHPOABD3jAAx7wgAc84AEPeMADHqI8tNBZzfAwve1U+E3tTAZ4YzzgAQ94KMWDelfRYw9iJniwNBD1VHMPs90kZg5LxyKMBx7wgIeyPVy30T9y2RUN0cOtRz+qjfbTCA94wAMe8IAHPPTBw0N+7PGABzzgAQ9mnSX33H/oQjgTaezbTMP1YN9fDV0FOuFhH7hwOIzs8IAHPHTXQ7aCyrJESIUgyv25V4qu82NT1HbKZm7nTWOEBzzgAQ94wAMe8IAHPOABD3jok4fDWhZ4KNlD2OBtYvG0s4+HdReiBQ+JPOIugsVDhIcDHvAg9FCZ75HOe4iYrPXCg8kQb6Y90uEsAw94wEOJHiqH0vlc8fx7MTf14JKnd7vUcHn5jbmHs/uo1LvFFy4uBulhery5TU5/PJz2ME8FMjv+luMBD3jAAx7wMFwPwqd9Kj2H975dnVRC53nY//mND1PmYJrZb7Fdr3e58fo56/zPSKm1T0j5+Nt0rgE7TSqum/efZ6P3IHtyaIQHPOChdx7q2qrFmrYr2iRulbI97HYSEA4eNic9KBpOeMADHvCABzzgYUAe7DtFgbG17TxZebjUcuqth8qszWqCwOephOF4EOqYiY9xLPyOb4zaWBnUJ1iXludW5/rTR+ZZ/5gYn61f2MBHwBVO7idf8YAHPOChRA/3jzmBBzwYeDj6weHBxcPlWgIPeMADHvCABzx0zcPxM2OHpOzP8ZCRvR4e7lPL7/++pu1lD4e/beAhfPCwVJfRp0cMeFB6yJ5FBLyFxDjIg98gbiJ9PPo2zMM230NKf/QxMzL+zhwPuzAPM38P/mM50U5J68HuaIZmBC2pFh6LCMG4YqupJfZmhziaWA/5qwQe8ICHgMphIr1GZioavQlaSnjIvr1mr2ZhsWvCAx7wgAc84CHSw7Vn5TARDhymoqNKiQy6l/o+SLZSGXubMiLWQ6oJPOABD3IP+iGc9kLWuXKb5ODhy4t3fC3IQ/rRV+frwPGABzz4eYjeKy1NJg4iB3euGyR/Dy+if5ehjI19WX1iFrFw3TThAQ94wAMe8IAHPOABD3jAAx7wgAdbDzfBvVb1EE5+wZhhg/WllLBrv8qvL1NfvaG8pSz75r6R4TvpqjxYDKW9Foas/3Qvpem3J5uwXTKMWJh7UK4RY7sVAg94wAMe8IAHPOABD3jAAx6cPFSKRuvlXutU0ls6WDWW7BqqVhh+xbNZq8nJQ1rjVXDyexV+qg8PeMCDdLNUqUYP2incXDB1SNgp3et3R0+B8RyhYiuZROyVkznVewhZ7JnwgAc84AEPePjAw02kh6X61NI8u3K4s7BwunB4ajmeNQ0ni0Iit8908SST5tCG/q0W8YAHPOABD3jAAx7wgAc84CHRg+BBIEV7aanlIHgEyMZD0NTNsNNk4yG/x6R+NCh0JIcHPOABD3jAQ4KHm46XDwanlhTFw1Mh8Sy/x08PYpN9iElQQLi9pdw/IPCABzy8xnd0H9isvLoryAAAAABJRU5ErkJggg==);

    span {
      position: relative;
      top: 0px;
      right: 0px;
      font-size: 12px;
      opacity: 0.6;
      float: right;
    }
  }

  @media screen and (max-width: 767px) {
    position: relative;

    a {
      padding: 0.25rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    position: relative;
  }
`;

export const StyledFilterOption = styled.option.attrs((props) => ({
  className: props.opened ? "opened" : props.button ? " nav nav-link" : "",
}))`
  h2 {
    text-transform: uppercase;
  }
`;

export const StyledFilterButton = styled.button`
  font-family: ${({ theme }) => {
    if (theme.skin === "pub") return "Ancho";
  }};
  text-transform: capitalize;
  cursor: pointer;
  color: ${({ theme, opened }) =>
    theme.skin === "abc" ||
    theme.skin === "nbc" ||
    theme.skin === "yet" ||
    theme.skin === "cac" ||
    theme.skin === "hyc"
      ? "#fff"
      : theme.skin === "rac"
        ? opened
          ? "#f7e500"
          : "var(--carouseltext)"
        : theme.skin === "fun"
          ? opened
            ? "var(--racProfileMenuCol)"
            : "#fff"
          : theme.skin === "yak"
            ? opened
              ? "#fcc239"
              : "#fff"
            : "var(--brandcolor)"};
  font-weight: ${({ theme }) =>
    theme.skin === "pub" ? "300" : theme.skin === "abc" ? "500" : "700"};
  text-transform: ${({ theme }) =>
    (theme.skin === "pub" || theme.skin === "rac") && "uppercase"};
  background-color: ${({ opened, theme }) => {
    if (opened) {
      if (theme.skin === "abc") return "#1f355e";
      if (theme.skin === "pub") return "#9A875D";
      if (theme.skin === "rac" || theme.skin === "nbc" || theme.skin === "qbc")
        return "transparent";
      if (theme.skin === "yet") return "#358bb7";
      else return "var(--menuhover)";
    } else return "transparent";
  }};

  text-decoration: ${({ opened, theme }) =>
    theme.skin === "qbc" && opened && "underline"};
  text-decoration-thickness: 3px;
  text-underline-offset: 8px;

  border-radius: ${({ opened, theme }) =>
    opened ? (theme.skin !== "cac" ? "0.5rem" : "28px") : ""};
  outline: 0;
  border: ${({ theme, opened }) =>
    theme.skin === "nbc" && opened
      ? "2px solid #e007ae"
      : theme.skin === "hyc" && opened
        ? "1px solid white"
        : "none"};
  padding: ${({ theme }) =>
    (theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun") &&
    isTablet
      ? "10px"
      : isTablet
        ? "12px"
        : "10px 20px"};
  display: ${({ display }) => (display ? "none" : "")};
  -moz-outline-style: none;
  outline-style: none;
  text-transform: ${({ theme }) =>
    // theme.skin === "abc" ||
    theme.skin === "nbc" ||
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "yak"
      ? "uppercase"
      : ""};
  font-size: ${({ theme }) =>
    ((theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun" ||
      theme.skin === "cac" ||
      theme.skin === "hyc" ||
      theme.skin === "yak") &&
      isTablet &&
      "0.6rem") ||
    (theme.skin === "pub" && "0.73rem")};

  &:focus {
    outline: 0;
  }
`;

export const GameSearchWrapper = styled.div`
  margin: ${({ theme }) =>
    (theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun") &&
    isMobile
      ? "1rem 0"
      : theme.skin === "yak"
        ? ""
        : "0 0 2rem 0"};
`;

export const StyledSearchName = styled.text`
  display: inline-block;
  overflow: hidden;
  max-width: 245px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StiledGamesInfo = styled.text`
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const StyledQuickGameCategories = styled.text`
  position: absolute;
  left: ${({ theme }) =>
    theme.skin === "qbc" ? (isMobileOnly ? "" : "250px") : "50%"};
  transform: ${({ theme }) => theme.skin !== "qbc" && "translateX(-50%)"};
  z-index: 10;
  /* padding-top: ${isMobileOnly ? "" : "40px"}; */
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  //align-items: spa;
  //align-content: space-between;
  text-transform: uppercase;
  letter-spacing: 1px;
  justify-content: center;
  font-size: ${({ theme }) => (theme.skin === "abc" ? "1rem" : "0.8rem")};

  .active {
    text-decoration: underline;
    text-decoration-color: ${({ theme }) =>
      theme.skin === "pub" ? "#9a875d" : "#FDAF1E"};
    text-decoration-thickness: 3px;
    text-underline-offset: 8px;
  }
  a {
    background: none;
    font-family: ${({ theme }) => theme.skin === "pub" && "Ancho"};
    padding: 0 25px;
    font-weight: ${({ theme }) => theme.skin === "pub" && "bold"};
    text-decoration: ${({ theme }) => theme.skin === "pub" && "underline"};
    text-decoration-color: ${({ theme }) => theme.skin === "pub" && "#9a875d"};
    text-decoration-thickness: ${({ theme }) => theme.skin === "pub" && "3px"};
    text-underline-offset: ${({ theme }) => theme.skin === "pub" && "8px"};
    transition: color 0.3s;

    &:hover {
      background: none;
      color: ${({ theme }) => theme.skin === "qbc" && "#bebebe"};
      //font-weight: bold;
      //color: white;
    }
  }
  /* .btn {
    color: ${({ theme }) => theme.skin === "pub" && "#acacac"};

      &:hover {
        color: #9a875d;
      }
      .active {
        color: #fff;
      }
    } */
  //overflow: hidden;
  //max-width: 500px;
  //white-space: nowrap;
  //text-overflow: ellipsis;

  @media screen and (max-width: 767px) {
    display: flex;
    top: ${({ theme, player }) =>
      theme.skin === "pub" ? (player ? "45px" : "80px") : "80px"};

    width: 100%;
    align-content: center;
    align-items: center;
    font-size: 0.9rem;
    justify-content: ${({ theme, hideOnScroll }) =>
      theme.skin === "pub" && (hideOnScroll ? "center" : "space-between")};
    left: ${({ theme }) => theme.skin === "qbc" && "0"};

    a {
      padding: 0px 10px;
    }
  }
`;
